// Error types (GraphQL errorType) the memory API answers with a short message already in the
// caller's language. Anything else (a timeout, a server fault, a network failure) is unexpected:
// its message is technical English and is never shown.
const EXPLAINED_ERROR_TYPES = [
  'CONFLICT',
  'SENSITIVE_TEXT',
  'INSTRUCTION_TEXT',
  'INVALID_INPUT',
  'Forbidden',
  'NOT_FOUND',
  'MEMORY_DISABLED',
  'PURGE_FAILED',
]

// Asking again gets the same answer: no automatic retry, no "Try again" button
const PERMANENT_ERROR_TYPES = ['Forbidden', 'NOT_FOUND', 'MEMORY_DISABLED']

/** The GraphQL errorType the fetcher kept on the error, if any. */
export const errorTypeOf = (error: unknown): string | undefined => {
  const type = (error as { errorType?: unknown } | null | undefined)?.errorType
  return typeof type === 'string' ? type : undefined
}

/** The API's own explanation, when it gave one; undefined for unexpected failures. */
export const explainedMessage = (error: unknown): string | undefined => {
  const type = errorTypeOf(error)
  if (!type || !EXPLAINED_ERROR_TYPES.includes(type) || !(error instanceof Error)) return undefined
  return error.message.trim() || undefined
}

export const isPermanentError = (error: unknown): boolean =>
  PERMANENT_ERROR_TYPES.includes(errorTypeOf(error) ?? '')

/**
 * Transient failures are retried twice. Refusals are not: they would be refused again (a stale
 * "show more" link is fixed by reloading the list, not by asking again).
 */
export const retryUnlessRefused = (failureCount: number, error: unknown): boolean =>
  !isPermanentError(error) && errorTypeOf(error) !== 'INVALID_INPUT' && failureCount < 2
